import React, { memo, useMemo } from "react";

import { FreeDeliveryIcon, isEmpty } from "@swiggy-private/core-ui";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import BenefitWrapper from "./BenefitWrapper";

import { createBenefits, isActive } from "@cart-ui/helpers/OfferBundle";

import { IMetaProps } from "../types";

import styles from "../styles/OfferPackNudgeWidget.scss";

const Content = ({ item }: IMetaProps) => {
    const benefits = useMemo(() => {
        if (!item) return [];

        if (isActive(item) && !isEmpty(item.subtitles)) {
            return createBenefits(item);
        }

        return item.benefits;
    }, [item]);

    if (!item) return null;

    return (
        <div className={styles.content}>
            <div className={styles.heading}>
                <FreeDeliveryIcon size={22} />
                <Text variant="V2.body1.neutral.bold">{item.title}</Text>
            </div>
            <BenefitWrapper benefits={benefits} />
        </div>
    );
};

export default memo(Content);
